import{jsx as r}from"react/jsx-runtime";import n from"styled-components";import p from"./LogoSv.js";import c from"./LogoEn.js";import"../../theme.js";const l=(o,t)=>t||(o==="en"?175:132),s=n.div`
  width: ${({width:o})=>o}px;
`,i=({locale:o,width:t,color:d})=>{const m=o==="en"?c:p,e=l(o,t);return r(s,{width:e,"data-testid":`logo-${o}`,children:r(m,{color:d})})};export{i as Logo,i as default};
